/* eslint-disable jira/filename-case */

import type { ResourceStoreContext } from '@atlassian/react-resource-router';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';

export const getSpaRouterContext = ({
	tenantContext,
}: ResourceStoreContext): {
	tenantContext: TenantContext;
} => ({
	tenantContext,
});
